import { FrameworkPolicies } from "~/pages/compliance/Framework/FrameworkOutlets";

const FrameworkPoliciesEntryPage = () => {
  return <FrameworkPolicies />;
};

export default FrameworkPoliciesEntryPage;
